import { Severity } from 'types/cases';

export const severityRequiresConfirmation = (data: Severity[], value: string) =>
    data
        ?.filter((item) => item.requiresConfirmation)
        .find((item) => item.level === value)?.requiresConfirmation;
